import { render, staticRenderFns } from "./MitEditUser.vue?vue&type=template&id=af524e24&scoped=true"
import script from "./MitEditUser.vue?vue&type=script&lang=js"
export * from "./MitEditUser.vue?vue&type=script&lang=js"
import style0 from "./MitEditUser.vue?vue&type=style&index=0&id=af524e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af524e24",
  null
  
)

export default component.exports